import { Component, computed, effect, Signal, signal, WritableSignal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingService } from './services/loading/loading.service';
import { ThemeService } from './services/theme/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Vex';
  loading: Signal<boolean> = computed(() => this.loadingService.state);

  constructor(
    private loadingService: LoadingService,
    private theme: ThemeService,
  ){}

}
